{
  "layout": {
    "title": "Paramètres",
    "description": "Gérez les paramètres et préférences de votre compte.",
    "adminTitle": "Paramètres",
    "adminDescription": "Gérez les paramètres et préférences de votre compte administrateur."
  },
  "nav": {
    "profile": "Profil",
    "business": "Entreprise",
    "password": "Mot de passe",
    "appearance": "Apparence",
    "language": "Langue",
    "notifications": "Notifications",
    "billing": "Facturation"
  },
  "profile": {
    "title": "Profil",
    "description": "Mettez à jour vos informations personnelles",
    "formTitle": "Informations du profil",
    "formDescription": "Mettez à jour votre nom, adresse e-mail et numéro de téléphone",
    "saving": "Enregistrement...",
    "saved": "Profil mis à jour avec succès",
    "saveError": "Échec de la mise à jour du profil",
    "name": "Nom",
    "nameDescription": "Votre nom complet",
    "namePlaceholder": "Nom complet",
    "email": "Adresse e-mail",
    "emailDescription": "Votre adresse e-mail",
    "emailPlaceholder": "Adresse e-mail",
    "phone": "Numéro de téléphone",
    "phoneDescription": "Votre numéro avec indicatif pays",
    "phonePlaceholder": "Numéro de téléphone",
    "invalidUsername": "Le nom d'utilisateur doit contenir 3 à 30 caractères : lettres minuscules, chiffres et underscores",
    "username": "Nom d'utilisateur",
    "usernameDescription": "Utilisé pour la connexion. Vous pouvez le modifier à tout moment.",
    "usernamePlaceholder": "nom_utilisateur",
    "usernameChecking": "Vérification de la disponibilité...",
    "usernameAvailable": "Nom d'utilisateur disponible",
    "invalidEmail": "E-mail invalide",
    "legacyTitle": "Profil utilisateur",
    "firstLastName": "Prénom et nom",
    "phoneRequired": "Le téléphone ne peut pas être vide",
    "changePasswordButton": "Changer le mot de passe",
    "photo": "Photo de profil",
    "photoDescription": "Téléversez une photo pour votre profil",
    "uploading": "Téléversement...",
    "uploadFailed": "Échec du téléversement"
  },
  "business": {
    "title": "Paramètres du profil d'entreprise",
    "description": "Gérez les informations et coordonnées de votre entreprise",
    "loadingTitle": "Profil d'entreprise",
    "loadingDescription": "Gérez les informations de votre entreprise",
    "noBusinessTitle": "Profil d'entreprise",
    "noBusinessDescription": "Aucune entreprise sélectionnée",
    "noBusinessHint": "Sélectionnez une entreprise pour gérer son profil.",
    "updating": "Mise à jour...",
    "update": "Mettre à jour",
    "saved": "Profil mis à jour avec succès",
    "uploadFailed": "Échec du téléversement",
    "uploading": "Téléversement...",
    "geocodeError": "Impossible de localiser cette adresse. Choisissez une suggestion dans la liste.",
    "imageAlt": "Entreprise",
    "name": "Nom de l'entreprise",
    "namePlaceholder": "Nom de votre entreprise",
    "descriptionLabel": "Description de l'entreprise",
    "descriptionPlaceholder": "Décrivez votre entreprise",
    "location": "Adresse",
    "locationHint": "Saisissez votre adresse et choisissez une suggestion dans la liste.",
    "locationPlaceholder": "ex. 123 rue Principale, Accra",
    "email": "E-mail de l'entreprise",
    "emailPlaceholder": "contact@entreprise.com",
    "emailRequired": "L'e-mail est requis",
    "emailInvalid": "E-mail invalide",
    "phone": "Téléphone de l'entreprise",
    "phonePlaceholder": "+1234567890",
    "industry": "Secteur d'activité",
    "industryHint": "Sélectionnez le secteur d'activité de votre entreprise",
    "industryPlaceholder": "Sélectionner un secteur",
    "industrySearch": "Rechercher un secteur...",
    "industryEmpty": "Aucun secteur trouvé"
  },
  "password": {
    "title": "Mot de passe",
    "description": "Mettez à jour votre mot de passe",
    "formTitle": "Changer le mot de passe",
    "formDescription": "Utilisez un mot de passe long et aléatoire pour sécuriser votre compte",
    "current": "Mot de passe actuel",
    "new": "Nouveau mot de passe",
    "confirm": "Confirmer le mot de passe",
    "saved": "Mot de passe mis à jour avec succès",
    "saveError": "Échec de la mise à jour du mot de passe",
    "saving": "Enregistrement...",
    "saveButton": "Enregistrer le mot de passe",
    "minLength": "8 caractères minimum",
    "mismatch": "Les mots de passe doivent correspondre",
    "legacyTitle": "Définir un nouveau mot de passe",
    "legacyDescription": "Saisissez votre ancien mot de passe et choisissez un nouveau mot de passe",
    "legacyBack": "Retour",
    "oldPasswordPlaceholder": "Saisissez votre ancien mot de passe",
    "newPasswordPlaceholder": "Saisissez votre nouveau mot de passe",
    "confirmPasswordPlaceholder": "Confirmez votre nouveau mot de passe",
    "changeSuccess": "Mot de passe modifié avec succès",
    "changeFailed": "Échec du changement de mot de passe"
  },
  "appearance": {
    "title": "Apparence",
    "description": "Mettez à jour les paramètres d'apparence de votre compte",
    "theme": "Thème",
    "themeDescription": "Sélectionnez votre thème préféré pour l'application.",
    "light": "Clair",
    "dark": "Sombre",
    "system": "Système"
  },
  "language": {
    "title": "Langue",
    "description": "Choisissez votre langue préférée pour l'application.",
    "english": "English",
    "french": "Français",
    "spanish": "Espagnol",
    "saved": "Langue mise à jour",
    "active": "Actif"
  },
  "notifications": {
    "title": "Notifications",
    "description": "Consultez et gérez votre activité récente et vos alertes.",
    "emptyTitle": "Aucune notification pour le moment",
    "emptyDescription": "Lorsque vous recevrez des mises à jour de rendez-vous, des demandes de créneaux et d'autres alertes, elles apparaîtront ici.",
    "updating": "Mise à jour de la notification…",
    "pageOf": "Page {{page}} sur {{total}}",
    "markAllSuccess": "Toutes les notifications ont été marquées comme lues",
    "markAllError": "Impossible de marquer les notifications comme lues",
    "markReadError": "Impossible de marquer la notification comme lue"
  }
}
